import {autoserializeAs} from "dcerialize";

export class Tag {
  @autoserializeAs(() => Number)
  public readonly id: number;
  @autoserializeAs(() => String)
  public readonly slug: string;
  @autoserializeAs(() => String)
  public readonly name: string;
}
